import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, Output } from '@angular/core';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';
import { Customer } from '@models/customer';
import { PortalWidgetDetailsComponent } from '../../portal-widget-details/portal-widget-details.component';
import { environment } from 'environments/environment';

const TITLE_COMPANY_ID = environment.titleCompanyId;

@Component({
    selector: 'app-billing-address-display',
    templateUrl: './billing-address-display.component.html',
    styleUrl: './billing-address-display.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PortalWidgetDetailsComponent, CtrlIconComponent],
})
export class BillingAddressDisplayComponent {
    @Output()
    public edit = new EventEmitter<void>();

    public customer = input.required<Customer>();
    protected isBusinessAccount = computed(() => this.customer().title.id === TITLE_COMPANY_ID);
}
